// 22.01.19 - Components for displaying button toolbars. Used by detail/form_toolbar.tsx.
import { WithStyles, withStyles } from "@material-ui/core";
import { toolbarStyles, CustomButton } from "src/styles/general";
import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";

interface IStaticButtonToolbarProps {
  actions: IButtonAction[];
}

interface IStaticButtonToolbarDispatchProps {
  dispatch: Dispatch;
}

interface IButtonAction {
  title: string;
  actions: any[];
  destructive?: boolean;
  btnClasses?: string;
}

type StaticButtonToolbarProps = IStaticButtonToolbarProps &
  IStaticButtonToolbarDispatchProps &
  WithStyles<typeof toolbarStyles>;

// This component simply renders a very simple row of buttons -- a toolbar
const StaticButtonToolbarComponent = (props: StaticButtonToolbarProps) => {
  const { classes } = props;
  const dispatchActions = (actions: any[]) => () => {
    actions.forEach((a) => props.dispatch(a));
  };
  return (
    <div className={classes.staticToolbarContainer}>
      {props.actions.map((btnAction, index) => {
        const cls =
          classes.staticToolbarButton +
          (btnAction.btnClasses ? " " + btnAction.btnClasses : "") +
          (btnAction.destructive
            ? " " + classes.staticToolbarDestructiveButton
            : "");
        return (
          <CustomButton
            key={index}
            className={cls}
            variant="contained"
            color="primary"
            onClick={dispatchActions(btnAction.actions)}
          >
            {btnAction.title}
          </CustomButton>
        );
      })}
    </div>
  );
};

export const StaticButtonToolbar = withStyles(toolbarStyles)(
  // @ts-ignore
  connect<{}, IStaticButtonToolbarDispatchProps, IStaticButtonToolbarProps>(
    null
  )(StaticButtonToolbarComponent)
);
